/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
//import Reflux from 'reflux';
import {hashHistory} from 'react-router'
import {Button} from 'antd';
import {DmsTab} from 'Components';
import {sKeylist} from '../../service/dictionary/dataitem';
import {detail} from '../../service/channelFunc';
import {config} from 'Utils'
import '../info/infodetail.css';

//import { Actions, Store} from './store';

class InfoDetail extends React.Component {
    constructor(props) {
        super(props);
        //this.store = Store;
        //this.storeKeys = ['detail'];
        this.state = {
            infoId: parseInt(this.props.params.id, 10),
            detail: {},
            channel_information: {}
        }
    }

    componentWillMount() { //准备数据
        const self = this;
        sKeylist({sKey: 'channel_information'}).then(res => { //类型
            if (res.status) {
                let obj = {};
                res.data.forEach(x => {
                    obj[x.sKey] = x.name
                });
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channel_information: obj})
                    }
                }, 200);
            }
        })
    }

    componentDidMount() {
        this.mounted = true;
        //Actions.getItem(this.state.infoId)
        const self = this;
        detail(this.state.infoId).then(res => {
            if (res.status) {
                self.setState({
                    detail: res.data,
                    enclosureId: res.data.enclosureId
                });
            }
        });
    }

    goView(url) {
        hashHistory.push(url);
    }

    goBack() {
        hashHistory.goBack();
    }

    openModal() {
        this.remarkModal.showModal();
    }

    render() {
        const {detail, infoId, channel_information} = this.state;
        console.log(detail)
        // let informationContent = {
        //       return
        // }
        return <div className="dms-main-box">
            <DmsTab options={[`${channel_information[detail.type + '']}`]} defaultKey={0}>
                <Button onClick={this.goBack}>返回</Button>
                {/*<Button onClick={this.goView.bind(this, `/channelFunc/add/${infoId}`)}>编辑</Button>*/}
            </DmsTab>
            <div className="dms-table-box">
                <div className="main">
                    <h1 className='detail_title'>{detail.title || ''}</h1>
                    <div className="main_detail">
                        <img className="detail_img" alt={`${detail.title}图片`}
                             src={detail.filePath ? `${config.server}${detail.filePath}` : ''}/>
                        <div className="message">
                            <p className='read'>{`阅读（${detail.clickCount}）`}</p>
                            <p className='comment'>评论（<a
                                href={`#/info/${infoId}/comment/list`}>{detail.commentCount}</a>）</p>
                        </div>

                    </div>
                </div>
                <div>
                    <a href={`${config.server}${detail.enclosurePath ? detail.enclosurePath.replace("getFile", "getFileDown") : null}`}
                       style={{display: (this.state.enclosureId && this.state.enclosureId != '') ? 'block' : 'none'}}
                    >
                        {`${detail.enclosureName}`}
                    </a>
                </div>
                <div className="info_content" dangerouslySetInnerHTML={{__html: detail.content}}></div>

            </div>

        </div>
    }
}
;
export default InfoDetail;



// WEBPACK FOOTER //
// ./src/routes/channelFunc/detail.js